import { useEffect, useState } from 'react';

export const FREE_TRIAL_MS = 8 * 24 * 60 * 60 * 1000;
const STORAGE_KEY = 'duo_free_trial_ends_at';

/** Resolve trial end: API date first, else persist now+8d in localStorage. */
export function resolveFreeTrialEndsAt(apiExpiresAt) {
    const fromApi = apiExpiresAt ? Date.parse(apiExpiresAt) : NaN;
    if (!Number.isNaN(fromApi) && fromApi > 0) return fromApi;

    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            const n = Number(stored);
            if (!Number.isNaN(n) && n > 0) return n;
        }
        const ends = Date.now() + FREE_TRIAL_MS;
        localStorage.setItem(STORAGE_KEY, String(ends));
        return ends;
    } catch {
        return Date.now() + FREE_TRIAL_MS;
    }
}

function pad(n) {
    return String(n).padStart(2, '0');
}

export function formatCountdown(msLeft) {
    const total = Math.max(0, Math.floor(msLeft / 1000));
    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    return { days, hours, minutes, seconds, expired: total <= 0 };
}

/**
 * Live countdown ticking every second until `endsAt` (ms timestamp).
 */
export default function useCountdown(endsAt) {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        if (!endsAt) return undefined;
        setNow(Date.now());
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, [endsAt]);

    if (!endsAt) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0, expired: true, label: '' };
    }

    const parts = formatCountdown(endsAt - now);
    const label = `${parts.days}d ${pad(parts.hours)}:${pad(parts.minutes)}:${pad(parts.seconds)}`;
    return { ...parts, label };
}
